import { InvestmentRoundingSetting } from './investment-rounding-setting';
import { roundShareCount } from './round-share-count';

export const roundInvestmentShares = (
  investedValue: number,
  sharePrice: number,
  setting: InvestmentRoundingSetting,
): number => {
  if (!sharePrice || sharePrice <= 0) {
    return 0;
  }

  return roundShareCount(investedValue / sharePrice, setting);
};
